import moment from 'moment';

export const STORE_FAVORITE_HOTELS = 'favorite-hotels';
export const STORE_FAVORITE_HOTELS_DOWNLOAD = 'favorite-hotels/download';

export const PROCESS_DOWNLOAD_REQUEST = 'processDownloadRequest';

export const PREVIOUS_MONTH_RANGE = [
  moment()
    .subtract(30, 'days')
    .toDate(),
  moment().toDate(),
];
export const PREVIOUS_WEEK_RANGE = [
  moment()
    .subtract(7, 'days')
    .toDate(),
  moment().toDate(),
];
